import { mobileTextCss, textCss } from 'common/utils/styleUtilsNew'
import { CheckboxUiInterface } from 'src/shared/components/checkbox/checkbox-ui.schema'
import { StrictRequired } from 'src/shared/types/typescript-utils/strict-required'
import styled, { css } from 'styled-components'

export type CheckboxUiProps = StrictRequired<
  Pick<CheckboxUiInterface, 'textAlign' | 'mobileTextAlign'>
>

const CheckboxUi = styled.div<CheckboxUiProps>`
  ${textCss}

  ${p => p.theme.phone} {
    ${mobileTextCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileTextCss}
    `}
`

export default CheckboxUi
